<template>
	<div id="app">
		<el-container>
			<el-header style='min-width: 1200px;'>
				<heade-login ></heade-login>
			</el-header>
			<el-main :style="{height: height + 'px'}"  style='position: relative;min-width: 1200px;'>
				<router-view  />
			</el-main>
		</el-container>
	</div>
</template>

<script>
	import HeadeLogin from './components/head/head.vue'
	export default {
		name: 'App',
		components: {
			HeadeLogin
		},
		data() {
			return {
				height:0
			};
		},
		mounted() {
			this.indexInfo()

		},
		methods:{
			indexInfo(){
				var info = document.body.clientHeight - 60
				this.height = info
			}
		}
	}
</script>

<style lang="scss">
	@import url('./assets/css/base.css');
	@import url('./assets/css/public.css');
	.el-header{
		border-bottom: 1px solid #CCCCCC;
	}
	div::-webkit-scrollbar {
		display: none;
	}

	.cardheader{
		.el-card__header {
		    padding: 0px 20px;
		    border-bottom: 1px solid #EBEEF5;
		    -webkit-box-sizing: border-box;
		    box-sizing: border-box;
			background-color: #eee;
		}
	}
</style>



// WEBPACK FOOTER //
// src/App.vue